import {goAxios} from "@/interceptors/axios";

class ServiceTicketService {

    async getOrderByBarcode(barcode, serviceTypeId) {
     //   console.log('Fetching service ticket with barcode:', barcode, 'and serviceTypeId:', serviceTypeId);
        return goAxios.get('/api/servicetickets/' + barcode + '?servicetype_id=' + serviceTypeId);
      // return goAxios.get('/api/servicetickets/' + barcode );
    }
    

    getServiceTicketSlot(serviceTicketId, pieceup = false, logscan = false, qpup = false, orderItemId = '', qcReturn = false) {
      const params = new URLSearchParams();
      if (pieceup) params.append('pieceup', '1');
      if (logscan) params.append('logscan', '1');
      if (qpup) params.append('qpup', '1');
      if (orderItemId) params.append('orderitem_id', String(orderItemId));
      if (qcReturn) params.append('qcreturn', '1');
      const queryString = params.toString();
     
      return goAxios.get('/api/servicetickets/' + serviceTicketId + '/slot' + (queryString ? '?' + queryString : ''));
    }

    clearServiceTicketSlot(serviceTicketId) {
        return goAxios.delete('/api/servicetickets/' + serviceTicketId + '/slot');
    }
  
  }
export default new ServiceTicketService();
